import React, { Component } from 'react';

class CartProduct extends Component {

    state = {
        isMouseOver: false
    };

    handleMouseOver = () => {
        this.setState({ isMouseOver: true });
    };

    handleMouseOut = () => {
        this.setState({ isMouseOver: false });
    };

    render() {
        const { product} = this.props;

        const classes = ['shelf-item-gis'];

        if (!!this.state.isMouseOver) {
            classes.push('shelf-item--mouseover');
        }

        return (
            <div className={classes.join(' ')}>
                <div
                    className="shelf-item__del"
                    onMouseOver={() => this.handleMouseOver()}
                    onMouseOut={() => this.handleMouseOut()}
                    onClick={() => this.props.removeCartGISData(product)}
                />
                <div className="shelf-item__details">
                    <p className="title">{product.name}</p>
                </div>
                <div className="shelf-item__price">
                    <p>RM {product.price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                </div>
            </div>
        );
    }
}

export default CartProduct;



// WEBPACK FOOTER //
// ./src/components/FloatCart/CartGISData.js